import React from "react";
import '../index.css';
import TopBar from "../components/TopBar";
import SideBar from "../components/SideBar";
import PosMain from "../pages/PosMain";

function PosMainLayout(){
    return (
    <>
     <PosMain />
    </>

    );
}

export default PosMainLayout;